import { render } from "./SectionLeaveReport.vue?vue&type=template&id=3f5821c9&scoped=true"
import script from "./SectionLeaveReport.vue?vue&type=script&lang=js"
export * from "./SectionLeaveReport.vue?vue&type=script&lang=js"

import "./SectionLeaveReport.vue?vue&type=style&index=0&id=3f5821c9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5821c9"]])

export default __exports__